import XIcon from '../../assets/icons/x.svg';

interface ModalWrapperProps {
    content?: string;
    id: string;
    disableCloseButton?: boolean;
    disableCloseOnOverlayClick?: boolean;
    extraClass?: string;
    title?: string;
}

export const ModalWrapper = ({
    content,
    id,
    disableCloseButton,
    disableCloseOnOverlayClick,
    extraClass,
    title,
}: ModalWrapperProps): {
    modalEl: HTMLDivElement;
    modalContentEl: HTMLDivElement;
} => {
    const titleEl = title ? `<h2 id="${id}-title" class="modal-header">${title}</h2>` : '';
    const closeButton = disableCloseButton ? '' : `<button class="modal-close btn-skin-2 btn-size-sm btn-only-icon" aria-label="Close modal" data-micromodal-close>${XIcon}</button>`;
    const overlay = disableCloseOnOverlayClick ? '<div class="hidden-close"></div>' : '<div class="hidden-close" data-micromodal-close></div>';

    const modalEl = document.createElement('div');
    modalEl.classList.add('modal');

    if (extraClass) {
        const extraClassArray = extraClass.split(' ');
        modalEl.classList.add(...extraClassArray);
    }

    modalEl.setAttribute('id', id);
    modalEl.setAttribute('aria-hidden', 'true');

    const modalOverlay = `
        <div class="modal-overlay" tabindex="-1">
            <div class="modal-container" role="dialog" aria-modal="true" ${title ? `aria-labelledby="${id}-title"` : ''}>
                ${titleEl}
                <div id="${id}-content" class="modal-content">
                    ${content ?? ''}
                </div>
                ${closeButton}
                ${overlay}
            </div>
        </div>
    `;

    modalEl.insertAdjacentHTML('beforeend', modalOverlay);
    const modalContentEl = modalEl.querySelector('.modal-content') as HTMLDivElement;

    return {
        modalEl,
        modalContentEl,
    };
};
